import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCartPricingRefreshing } from '../../contexts/CartPricingContext';
import * as types from '../../types';
import { useCartCheckout } from '../CartSummary/CartActions';
import useHardwareFirstTotals from '../HardwareFirstCart/useHardwareFirstTotals';
import styles from './HardwareFirstCheckoutBar.module.scss';

interface HardwareFirstCheckoutBarProps {
  id?: string;
  onCheckOut: (checkoutCart: types.Cart, cartPricing: types.CartPricing) => void;
}

/** The mobile cart's pinned bar: the pre-tax subtotal and the route into checkout. */
export default function HardwareFirstCheckoutBar({ id, onCheckOut }: HardwareFirstCheckoutBarProps) {
  const { t } = useTranslation();
  const { hardwareInCents, discountInCents, promoPercentOff, totalInCents, formatPrice } = useHardwareFirstTotals();
  const checkout = useCartCheckout(onCheckOut);
  const refreshing = useCartPricingRefreshing();

  return (
    <div className={styles.bar} id={id}>
      <div className={styles.priceRow}>
        <span className={styles.dueToday}>{t('subtotal')}</span>
        <span className={classNames(styles.price, { [styles.pending]: refreshing })} aria-busy={refreshing}>
          {discountInCents > 0 && (
            <span className={styles.pill}>
              {promoPercentOff > 0
                ? t('hardware_first_percent_off', { percent: promoPercentOff })
                : t('hardware_first_amount_off', { amount: formatPrice(discountInCents) })}
            </span>
          )}
          <span className={styles.total}>{formatPrice(totalInCents)}</span>
          {discountInCents > 0 && <span className={styles.listPrice}>{formatPrice(hardwareInCents)}</span>}
        </span>
      </div>
      <button className={styles.checkoutButton} onClick={checkout} type="button">
        {t('checkout')}
      </button>
    </div>
  );
}
